import React from 'react';
import FAQ from '../components/Faq';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <>
      <Header />

      <div className="bg-gray-50 dark:bg-gray-900">
        <header className="py-16 text-center">
          <h1 className="text-5xl font-extrabold text-gray-900 dark:text-white">About Us</h1>
          <p className="mt-6 text-xl text-gray-700 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Welcome to <strong>OnlySale</strong>, your one-stop destination where the world comes to shop and sell. Dive into a marketplace bursting with unique products from every corner of the globe. Whether you’re hunting for that rare find or looking to showcase your own creations, OnlySale is the place where your shopping adventures begin.
          </p>
          <p className="mt-4 text-xl text-gray-700 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We’re not just about products; we’re about possibilities. Our journey started with a simple idea: bring the best of global offerings to your doorstep. Today, we proudly serve customers worldwide, curating a collection that reflects quality, diversity, and innovation. Join us as we continue to expand and evolve, turning passions into thriving businesses.
          </p>
        </header>

        <section className="py-16 bg-white dark:bg-gray-800">
          <div className="mx-auto max-w-screen-lg px-6 lg:px-8">
            <h2 className="text-4xl font-semibold text-gray-900 dark:text-white text-center">Our Mission</h2>
            <p className="mt-6 text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed text-center">
              At OnlySale, our mission is clear: to connect people with the world’s most exceptional products while providing a platform for sellers to shine. We’re dedicated to fostering a community built on trust, quality, and innovation. Every interaction is an opportunity to create something special, and we’re here to make sure your experience is nothing short of extraordinary.
            </p>
          </div>
        </section>

        <section className="py-16 bg-white dark:bg-gray-900">
          <div className="mx-auto max-w-screen-lg px-6 lg:px-8">
            <FAQ />
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;
